import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { IThread } from '@fly/shared';
import {
  clearSuggestions,
  selectCurrentThreadId,
  setGeneralSuggestions,
  setThreadId,
  useAppDispatch,
} from '@fly/store';

interface UseThreadInitParams {
  currentThread: IThread | null;
  isThreadLoading: boolean;
}

export const useThreadInit = ({
  currentThread,
  isThreadLoading,
}: UseThreadInitParams) => {
  const dispatch = useAppDispatch();

  const [isInitialized, setIsInitialized] = useState(false);

  const storedThreadId = useSelector(selectCurrentThreadId);

  useEffect(() => {
    if (isInitialized || isThreadLoading) return;
    setIsInitialized(true);

    if (!storedThreadId) {
      dispatch(setGeneralSuggestions());
      return;
    }

    if (currentThread) {
      dispatch(setThreadId(currentThread.thread_id));
      dispatch(clearSuggestions());
    } else {
      dispatch(setThreadId(null));
    }
  }, [dispatch, isInitialized, currentThread, isThreadLoading, storedThreadId]);
};
